import { Type, Square, Minus, Image, QrCode, Upload, Tag, Lock } from "lucide-react";
import { DYNAMIC_FIELDS, elLabel, elIcon } from "./editorConstants";

export function EditorLeftPanel({
  elements, selected, bgColor, bgImage,
  onAddElement, onUploadCustomImage, onSelectElement,
  onBgColorChange, onUploadBgImage, onRemoveBgImage,
}) {
  return (
    <div className="w-52 bg-white border-r border-slate-200 overflow-y-auto shrink-0 p-2.5" data-testid="editor-left-panel">
      <p className="text-[9px] font-bold text-slate-400 uppercase tracking-[0.15em] mb-1.5">Anadir elementos</p>
      <div className="space-y-0.5">
        {[
          { fn: () => onAddElement("text"), icon: <Type className="w-3.5 h-3.5" />, label: "Texto estatico", tid: "add-text-btn" },
          { fn: () => onAddElement("shape"), icon: <Square className="w-3.5 h-3.5" />, label: "Bloque / forma", tid: "add-shape-btn" },
          { fn: () => onAddElement("shape", { shape: "line", height: 0.15, width: 80, color: "#e2e8f0" }), icon: <Minus className="w-3.5 h-3.5" />, label: "Linea separadora", tid: "add-line-btn" },
          { fn: () => onAddElement("image"), icon: <Image className="w-3.5 h-3.5" />, label: "Logo corporativo", tid: "add-logo-btn" },
          { fn: () => onAddElement("qr"), icon: <QrCode className="w-3.5 h-3.5" />, label: "Codigo QR", tid: "add-qr-btn" },
        ].map(b => (
          <button key={b.tid} onClick={b.fn} className="w-full flex items-center gap-2 px-2 py-1.5 text-[11px] text-slate-600 hover:bg-slate-50 rounded transition-colors" data-testid={b.tid}>
            {b.icon} {b.label}
          </button>
        ))}
        <label className="w-full flex items-center gap-2 px-2 py-1.5 text-[11px] text-slate-600 hover:bg-slate-50 rounded cursor-pointer transition-colors">
          <Upload className="w-3.5 h-3.5" /> Imagen propia
          <input type="file" accept="image/*" className="hidden" onChange={onUploadCustomImage} data-testid="upload-custom-image" />
        </label>
      </div>

      <p className="text-[9px] font-bold text-slate-400 uppercase tracking-[0.15em] mb-1.5 mt-3">Campos dinamicos</p>
      <div className="space-y-0 max-h-[220px] overflow-y-auto">
        {DYNAMIC_FIELDS.map(f => (
          <button key={f.id} onClick={() => onAddElement("dynamic_field", { field: f.id, label: f.label.toUpperCase() })}
            className="w-full flex items-center gap-2 px-2 py-1 text-[10px] text-slate-500 hover:bg-blue-50 hover:text-blue-700 rounded transition-colors" data-testid={`add-field-${f.id}`}>
            <Tag className="w-2.5 h-2.5 text-blue-400" /> {f.label}
          </button>
        ))}
      </div>

      <p className="text-[9px] font-bold text-slate-400 uppercase tracking-[0.15em] mb-1.5 mt-3">Fondo</p>
      <div className="space-y-1.5">
        <div className="flex items-center gap-2">
          <input type="color" value={bgColor} onChange={e => onBgColorChange(e.target.value)} className="w-6 h-6 rounded border cursor-pointer" data-testid="bg-color-picker" />
          <span className="text-[10px] text-slate-500">Color</span>
        </div>
        <label className="flex items-center gap-2 px-2 py-1.5 text-[10px] text-slate-600 hover:bg-slate-50 rounded cursor-pointer border border-dashed border-slate-300">
          <Upload className="w-3 h-3" /> {bgImage ? "Cambiar fondo" : "Imagen fondo"}
          <input type="file" accept="image/*" className="hidden" onChange={onUploadBgImage} data-testid="bg-image-upload" />
        </label>
        {bgImage && <button onClick={onRemoveBgImage} className="text-[10px] text-red-500 hover:underline" data-testid="remove-bg-image">Quitar imagen</button>}
      </div>

      <p className="text-[9px] font-bold text-slate-400 uppercase tracking-[0.15em] mb-1.5 mt-3">Capas ({elements.length})</p>
      <div className="space-y-0 max-h-[180px] overflow-y-auto">
        {[...elements].reverse().map(el => (
          <button key={el.id} onClick={() => onSelectElement(el.id)}
            className={`w-full flex items-center gap-1.5 px-1.5 py-1 text-[10px] rounded transition-colors ${selected === el.id ? "bg-blue-100 text-blue-800 font-semibold ring-1 ring-blue-300" : "text-slate-500 hover:bg-slate-50"}`}>
            {elIcon(el)}
            <span className="truncate flex-1 text-left">{elLabel(el)}</span>
            {el.locked && <Lock className="w-2.5 h-2.5 text-amber-400 shrink-0" />}
          </button>
        ))}
      </div>
    </div>
  );
}
